import { useState } from "react";
import { useAuthHeader, useAuthUser } from '../../../Services/Auth/sessionAuth';
import { Button, Form, Radio, Space, Spin, Tabs } from 'antd';
import Utilisateur from "../../../Models/Utilisateur";
import type { TabsProps } from 'antd';
import { UserOutlined, ContactsOutlined, UsergroupAddOutlined } from '@ant-design/icons';
import SweetAlert from "sweetalert2";
import Swal from "sweetalert2";
import Tab1 from "./Tab1";
import { Box, Typography } from '@mui/material';
import SearchModal from "../../SearchModal";
import InputForm from "../../InputT";
import SelectOption from "../../SelectOption";
import DataSelect from '../../../Types/DataSelect'
import ParamsPicklist from "../../../Types/ParamsPicklist";
import SearInputG from "../../SearchInput"
import { Crypter } from "../../../Functions/Security/Crypter";
import Data from '../../../Data/Data.json';
import axios from "axios";
import ReformatDate from '../../../Functions/Traitement/ReformatDate'
import Demand from '../../../Models/MTypepret';
import formatDate from "../../../Functions/Traitement/fomatDate";
import { date } from "yup";
import CheckBox from "../../CheckBox";
import type { CheckboxChangeEvent } from 'antd/es/checkbox';

import CheckStan from "../../Prints/CheckStan";
import RadioBox from "../../Radiox";


const Socity = () => {

    const dataOption2: DataSelect[] = [
        { label: "Simple", value: "1" },
        { label: "Moyen", value: "2" },
        { label: "Complet", value: "3" }
    ]

    const auth = useAuthUser()
    const Perss: Utilisateur = JSON.parse(JSON.stringify(auth()))
    const authHeader = useAuthHeader()
    const [Onfinis, SetOnfinis] = useState<number>(0);
    const [form] = Form.useForm();
    const [loading, setLoading] = useState(false);
    const [SearchGlobal, setSearchGlobal] = useState(false);
    const [isSubmit, setIsSubmit] = useState(false);
    const [Consultactv, setConsulte] = useState(false);
    const [Ajoutactv, setAjoute] = useState(false);
    const [Modifactv, setModife] = useState(true);
    const [Supprimactv, setSupprime] = useState(true);
    const [Enregactv, setEnrege] = useState(true);
    const [Actuactv, setActue] = useState(true);
    const [Annulactv, setAnnule] = useState(true);
    const [FormAct, setFormactve] = useState(true);
    const [sbmit, setSbmit] = useState("")
    const [Idbutton, setIdbutton] = useState(false);
    const [Idbutton2, setIdbutton2] = useState(true);
    const [Activetabs, SetActivetabs] = useState(false);

    // Handle function
    function HandleConsult() {
        setConsulte(true);
        setAjoute(true);
        setModife(false);
        setAnnule(false);
        setSupprime(false);
        setIdbutton(true);
        SetActivetabs(true)
        setIdbutton2(true);
    }

    function HandleAjout() {



        setConsulte(true);
        setAjoute(true);
        setEnrege(false);
        setActue(false);
        setAnnule(false);
        setFormactve(false);
        setSbmit('add');
        setIdbutton2(false);

    }

    function HandleModif() {
        setEnrege(false);
        setModife(true);
        setActue(false);
        setAnnule(false)
        setFormactve(false);
        setSbmit('modif')
        setSupprime(true)
        SetActivetabs(false)
        setIdbutton2(false);
    }

    function HandleSupp() {
        setSbmit('supp')
    }

    function HandleAnnul() {

        setConsulte(false);
        setAjoute(false);
        setModife(true);
        setEnrege(true);
        setSupprime(true);
        setActue(true);
        setAnnule(true);
        //form.resetFields();
        setFormactve(true);
        setSbmit('')
        setIdbutton(false);
        SetActivetabs(false)
        setIdbutton2(true);
    }

    const items: TabsProps['items'] = [
        {
            key: '1',
            label: (
                <span id='x'>
                    {/* //<UserOutlined /> */}
                    Paramètre Socièté 1
                </span>
            ),
            children: <>
                <div className='tabItem' >

                    <div style={{ display: 'block flow' }}  >
                        <Box fontStyle="inherit" className='border' width={"85%"} position={"absolute"} style={{ marginTop: -10 }} >
                            <fieldset className="bordure1">

                                <Box style={{ display: 'flex', marginTop: -5 }}>

                                    <Box style={{ width: '58%' }}>
                                        <Box style={{ marginBottom: -7, width: '100%' }}>
                                            <SearInputG width={7} dissabledLib={Idbutton2} dissabledCode={Idbutton2} notremove Titre=" Recherche" label='Code Socièté' name="TYPEPRET" Taille1={'100%'} Taille2={'164%'}  /* etat={props.setSearchGlobal} */ form={form} />
                                        </Box>
                                        <Box style={{ marginTop: -10, width: '100%' }}>
                                            <InputForm width={7} label="Licence" type="text" name="ECARTECHPEN" />
                                        </Box>
                                        <Box style={{ marginTop: -10, width: '100%' }}>
                                            <InputForm width={7} label="Coopérative" type="text" name="ECARTECHPEN" />
                                        </Box>
                                        <Box style={{ marginTop: -10 }}>
                                            <SearchModal width={7} Titre="" label="Id Plan Escompe Chéque" name="IDPLIMPAYE" Taille1={'100%'} Taille2={'164%'} form={form} />
                                        </Box>
                                        <Box style={{ marginTop: -10 }}>
                                            <SearchModal width={7} Titre="" label="Id Plan Chèque Encai... Client" name="IDPLIMPAYE" Taille1={'100%'} Taille2={'164%'} form={form} />
                                        </Box>
                                    </Box>
                                    <Box style={{ width: '38%' }}>
                                        <Box style={{ marginTop: 0, width: '100%' }}>
                                            <InputForm width={15} label="Nbres de jours date valeur chèque" type="number" name="TAUXQUODITE" />
                                        </Box>
                                        <Box style={{ marginTop: -10, width: '100%' }}>
                                            <InputForm width={15} label="Fréquence validation des litiges" type="number" name="TAUXQUODITE" />
                                        </Box>
                                        <Box style={{ marginTop: -10, width: '100%' }}>
                                            <InputForm width={15} label="Fréquence confirmation des litiges" type="number" name="TAUXQUODITE" />
                                        </Box>
                                        <Box style={{ marginTop: -10, width: '100%' }}>
                                            <InputForm width={15} label="Boîte Postale" type="number" name="TAUXQUODITE" />
                                        </Box>
                                    </Box>

                                </Box>

                            </fieldset>
                            <fieldset className="bordure1">
                                <Box style={{ display: 'flex', marginTop: -5 }}>
                                    <Box style={{ width: '40%' }}>
                                        <Box style={{ marginTop: 0, width: '100%' }}>
                                            <InputForm width={14} label="Le Mot de Passe Expire Aprés :" type="number" name="expire" />
                                        </Box>
                                        <Box style={{ marginTop: -10, width: '100%' }}>
                                            <InputForm width={14} label="Nbre Tentative de Connexion" type="number" name="nbrtentative" />
                                        </Box>
                                    </Box>
                                    <Box style={{ width: '25%' }} >
                                        <Box style={{ marginTop: 12, marginBottom: -35, marginLeft: 19, width: '100%' }}>
                                            <CheckStan width={18} label={"Clé de Compte Numerique"} name={"ISKEYCPTNUMERIC"} />
                                        </Box>
                                        {/* <Box style={{ marginTop: -10, marginBottom: -35, marginLeft: 19, width: '100%' }}>
                                            <CheckStan width={18} label={"Agence Principal ?"} name={"ISAGCEPRINCIPAL"} />
                                        </Box> */}

                                    </Box>
                                    <Box style={{ width: '25%' }}>
                                        <Box style={{ marginTop: 0, width: '100%' }}>
                                            <InputForm width={0} label="Jour Compte Courant Débit" type="texte" name="PARVALD" />
                                        </Box>

                                        <Box style={{ marginTop: -10, width: '100%' }}>
                                            <InputForm width={0} label="Jour Compte Epargne Débit" type="texte" name="PAREPD" />
                                        </Box>
                                    </Box>
                                    <Box style={{ width: '19%' }}>
                                        <Box style={{ marginTop: 0, width: '100%' }}>
                                            <InputForm width={0} label="Crédit" type="texte" name="PARVALI" />
                                        </Box>
                                        <Box style={{ marginTop: -10, width: '100%' }}>
                                            <InputForm width={0} label="Crédit" type="texte" name="PAREPC" />
                                        </Box>
                                    </Box>
                                </Box>
                            </fieldset>
                            <fieldset className="bordure1">
                                <Box style={{ marginTop: -10, width: '80%' }}>
                                    <InputForm width={0} label="Pub 1" type="text" name="PUBLI1" />
                                </Box>
                                <Box style={{ marginTop: -10, width: '80%' }}>
                                    <InputForm width={0} label="Pub 2" type="text" name="PUBLI2" />
                                </Box>
                                <Box style={{ marginTop: -10, width: '80%' }}>
                                    <InputForm width={0} label="Message Publicitaire" type="text" name="MSGPUBNETSOFT" />
                                </Box>
                            </fieldset>



                        </Box>
                    </div>
                </div >
            </>,
        }, {
            key: '2',
            label: (
                <span id='x'>
                    <UserOutlined />
                    Paramètre Socièté 2
                </span>
            ),
            children: <>
                <div className='tabItem' >
                    <div style={{ display: 'block flow' }}  >
                        <Box fontStyle="inherit" className='border' width={"85%"} position={"absolute"}  >
                            {/* <legend> Creation Agence  </legend> */}
                            <Box style={{ display: 'flex', marginTop: 5 }}>
                                <Box style={{ display: "flex" }}>
                                    <fieldset className="bordure1">
                                        <Box >
                                            <Box style={{ marginTop: 5, marginBottom: -35, paddingLeft: 13 }}>
                                                <CheckStan width={21} label={"Gestion des Remboursements Partiels"} name={"GESPRETDETAIL"} />
                                            </Box>
                                            <Box style={{ marginTop: -10 }}>
                                                <InputForm width={15} label="Remboursement Partiel Limité à " type="number" name="NBRJRFIXREMB" taille={160} />
                                            </Box>
                                            <Form.Item style={{ width: '100%', marginTop: -13, marginBottom: -12 }} >
                                                < SelectOption Option={dataOption2} width={15} label="Schéma Traitement Chèque" Size={'100%'} name="STRAITCHQ" />
                                            </Form.Item>
                                            <Box >
                                                <CheckStan width={21} label={"Choisir le type d'intérêt/Commission lors du calcul des agios"} name={"ISCHOSEINT"} />
                                            </Box>
                                            <Box style={{ marginTop: -30 }}>
                                                <CheckStan width={21} label={"Gestion Auto des écritures liées au manquant ou exédent"} name={"GESAUTOERCAI"} />
                                            </Box>
                                            <Box style={{ marginTop: -30, marginBottom: -30 }}>
                                                <CheckStan width={21} label={"Calcul Agios Compte Ouverts première Quinzaine "} name={"iscalfirsweek"} />
                                            </Box>
                                            <Box >
                                                <CheckStan width={21} label={"Calcul Agios Compte Ouverts Deuxième Quinzaine "} name={"iscalsweek"} />
                                            </Box>

                                            <Box style={{ marginTop: -30 }}>
                                                <CheckStan width={21} label={"Modifier le Type d'intérêt et Commission Dans Controle de Cpte"} name={"iseditintcom"} />
                                            </Box>
                                            <Box style={{ marginTop: -30, marginBottom: -30 }} >
                                                <CheckStan width={21} label={"Ne pas Confirmer les litiges à la Caisse ?"} name={"isnotconfcai"} />
                                            </Box>
                                        </Box>
                                    </fieldset>
                                    <fieldset className="bordure1" style={{ display: 'flex' }}>

                                        <Box>
                                            <Box style={{}}>
                                                <CheckStan width={21} label={"Systéme Arrêt Caisse"} name={"ARRETCAIS"} />
                                            </Box>
                                            <Box style={{ marginTop: -30 }}>
                                                <CheckStan width={21} label={"Voir Encaisse Informatique"} name={"ENCINF"} />
                                            </Box>
                                            <Box style={{ marginTop: -30, marginBottom: -30 }}>
                                                <CheckStan width={21} label={"Gestion Automatique des Erreur"} name={"GESAUTOERCAI"} />
                                            </Box>
                                            <Box >
                                                <CheckStan width={21} label={"Coloriser le Formulaire Billetage des Caisses "} name={"ISCASHCOLOR"} />
                                            </Box>
                                            <Box style={{ marginTop: -30 }}>
                                                <CheckStan width={21} label={"Manquant et Excedent Limite à la Caisse ?"} name={"ismanqlim"} />
                                            </Box>
                                            <Box style={{ marginTop: -30, marginBottom: -30 }}>
                                                <CheckStan width={21} label={"Validations des Opérations En Back-Office"} name={"isvalidinbo"} />
                                            </Box>
                                            <Box >
                                                <CheckStan width={21} label={"Validation des Impayés"} name={"IMPAYE"} />
                                            </Box>
                                        </Box>
                                    </fieldset>
                                    <fieldset className="bordure1">
                                        <Box style={{ display: 'flex' }}>
                                            <Box>
                                                <Box >
                                                    <CheckStan width={21} label={"Commission sur Retrait en Compte Epargne"} name={"isComRetEpar"} />
                                                </Box>
                                                <Box style={{ marginTop: -30 }}>
                                                    <CheckStan width={21} label={"Commission sur Retraits Avec Chèque Guichet"} name={"iscomChqGuich"} />
                                                </Box>
                                                <Box style={{ marginTop: -30, marginBottom: -30 }}>
                                                    <CheckStan width={21} label={"Validation des Comptes"} name={"IsValidCpte"} />
                                                </Box>
                                                <Box style={{ marginTop: -30, marginBottom: -30 }}>
                                                    <CheckStan width={21} label={" Autoriser Multiple Litige Sur Compte?"} name={"isMultiLitige"} />
                                                </Box>
                                                <Box style={{ marginTop: -30, marginBottom: -30 }}>
                                                    <CheckStan width={21} label={"Modifier Nom du Compte ?"} name={"isModifNomCpt"} />
                                                </Box>
                                                <Box style={{ marginTop: -30 }}>
                                                    <CheckStan width={21} label={"Validation Prêt: Utilisateur Différent ?"} name={"isUtivalDiffUtisaiPret"} />
                                                </Box>
                                            </Box>
                                        </Box>
                                    </fieldset>
                                </Box>

                            </Box>
                            <Box>

                            </Box>
                        </Box>
                    </div>
                </div >
            </>,
        }, {
            key: '3',
            label: (
                <span id='x'>
                    <UserOutlined />
                    Parametre Format
                </span>
            ),
            children: <>
                <div className='tabItem' >

                    <div style={{ display: 'block flow' }}  >
                        <Box fontStyle="inherit" className='border' width={"85%"} position={"absolute"}  >

                            <fieldset className="bordure1" style={{ width: '60%' }}>
                                <Box style={{ marginBottom: -7, width: '100%' }}>
                                    <SearInputG width={7} dissabledLib={Idbutton2} dissabledCode={Idbutton2} notremove Titre=" Recherche" label='Code EMF' name="TYPEPRET" Taille1={'100%'} Taille2={'169%'}  /* etat={props.setSearchGlobal} */ form={form} />
                                </Box>
                                <Box style={{ marginTop: 0, width: '100%' }}>
                                    <InputForm width={7} label="Séparateur" type="texte" name="PARVALD" />
                                </Box>
                                <Box style={{ marginTop: -10, width: '100%' }}>
                                    <InputForm width={7} label="Longueur Plan Comptable" type="int" name="PARVALD" />
                                </Box>
                                <Box style={{ marginTop: -10, width: '100%' }}>
                                    <InputForm width={7} label="Longueur Code Agence" type="int" name="PARVALD" />
                                </Box>
                                <Box style={{ marginTop: -10, width: '100%' }}>
                                    <InputForm width={7} label="Longueur Indice Client " type="int" name="PARVALD" />
                                </Box>
                                <Box style={{ marginTop: -10, width: '100%' }}>
                                    <InputForm width={7} label="Longueur Code Produit" type="int" name="PARVALD" />
                                </Box>
                                <Box style={{ marginTop: -10, width: '100%' }}>
                                    <InputForm width={7} label="Longueur Clés" type="int" name="PARVALD" />
                                </Box>
                            </fieldset>

                        </Box>
                    </div>
                </div >
            </>,
        }
    ];


    // function Onfinish
    const onFinish = (values: any) => {

    }

    // function consult 
    function consult() {

    }

    // function de verification 
    const onFinishFailed = async (errorInfo: any) => {
        var errors: any = [];
        errorInfo.errorFields.map((error: any) => {
            errors.push(error.name + "");
        })
        SweetAlert.fire({ title: "Veuillez remplir tous les champs obligatoires", text: errors.toString().replaceAll(',', " - "), icon: 'warning', confirmButtonText: 'OK' })
    };

    const verifSubmit = () => {
        if (!isSubmit) {
            Swal.fire({ title: "Attention", text: "Veillez remplir tous les champs", icon: "warning" })
        }
    };

    return (
        <div className='tab'>
            <Typography align='center' className='formTitle'> <b> PARAMETRE SOCIETE: {window.location.pathname.toUpperCase()} </b> </Typography>
            <Spin spinning={loading} size='large' style={{ color: 'green' }}>
                <Form disabled={FormAct} autoComplete="off" labelAlign='left' form={form} name="dynamic_form_complex" onFinish={onFinish} onFinishFailed={onFinishFailed} style={{ minWidth: 'auto', maxWidth: 'auto' }}>
                    <div className='bG'>
                        <legend><Typography color={"darkgreen"}>Actions</Typography></legend>
                        <Form.Item shouldUpdate className='bouttong'>
                            <Space direction="vertical" style={{ width: '100%' }}>
                                <Button size='large' className='bt_add' disabled={Consultactv} onClick={() => { consult() }} type="ghost" htmlType="button" block  >
                                    Consulter
                                </Button>
                                <Button size='large' className='bt_add' disabled={Ajoutactv} onClick={() => { HandleAjout() }} type="ghost" htmlType="button" block  >
                                    Ajouter
                                </Button>
                                <Button size='large' className='bt_add' disabled={Modifactv} onClick={() => { HandleModif() }} type="ghost" htmlType="button" block  >
                                    Modifier
                                </Button>
                                <Button size='large' className='bt_add' disabled={Enregactv} type="ghost" htmlType="submit" block>
                                    Enregistrer
                                </Button>
                                <Button size='large' className='bt_add' disabled={Supprimactv} onClick={() => { HandleSupp() }} type="ghost" htmlType="submit" block>
                                    Supprimer
                                </Button>
                                <Button size='large' className='bt_add' disabled={Actuactv} onClick={() => { form.resetFields() }} type="ghost" htmlType="button" block  >
                                    Actualiser
                                </Button>
                                <Button size='large' disabled={Annulactv} onClick={() => { HandleAnnul() }} className='bt_add' type="ghost" htmlType="reset" block>
                                    Annuler
                                </Button>
                            </Space>
                        </Form.Item>
                    </div>
                    <div className='clientP'>
                        <div>
                            <div >
                                <Tabs onChange={e => { if (Activetabs == true) { consult() } }} size='large' type="card" defaultActiveKey="1" items={items} />
                            </div>
                        </div>
                    </div>
                </Form>
            </Spin>
        </div>
    )
}

export default Socity;